export default "__VITE_ASSET__oKsEpHjX__"